export default function AppHeader(): JSX.Element {
  return (
    <>
      <h1 className="title">
        Welcome to my shopping App. I hope you find this useful!
      </h1>
    </>
  );
}
